import React, { Component } from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';

import { DataOperation } from '../../data/DataOperation';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

// Props :
// idOperation

//#region CSS
const classNames = mergeStyleSets({
    modalContainer: {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '60vh',
        maxWidth: '800px',
        width: '60vw'
    },
    modalScrollableContent: {
        display: 'flex',
        flexDirection: 'column'
    },
    modalHeader: {
        background: '#fd0400',
        color: 'white',
        padding: '8px 28px 0'
    },
    modalBody: {
        flex: '2 2',
        overflowY: 'auto',
        padding: '5px 28px'
    },
    modalFooter: {
        display: 'flex',
        justifyContent: 'center',
        padding: '15px 28px',
    }
});
//#endregion

export class ModalOperationDates extends Component {

    constructor(props) {
        super(props);

        this.state = {
            items: [],
            idOperation: null,
            onAfficheModal: false
        }

        let columnsTemp = [];
        columnsTemp.push({
            key: 'nomDate',
            name: 'Date',
            fieldName: 'nomDate',
            minWidth: 200,
            maxWidth: 400,
            isResizable: true
        });
        columnsTemp.push({
            key: 'datePrevisionnellePassee',
            name: 'Valeur',
            fieldName: 'datePrevisionnellePassee',
            minWidth: 200,
            maxWidth: 300,
            isResizable: true,
            onRender: (item) => {
                let datePrevisionnellePassee = Scriba.date().stringDateFormatCourt(item.datePrevisionnellePassee);
                return <span title={datePrevisionnellePassee}>{datePrevisionnellePassee}</span>;
            }
        });

        this.columns = columnsTemp;
    };

    componentDidUpdate = () => {
        let propsIdOperationRenseignee = Immocom.getSiPropsRenseignee(this.props.idOperation);
        let propsIdOperationDifferentDeStateIdOperation = (this.props.idOperation !== this.state.idOperation);

        if (propsIdOperationRenseignee && propsIdOperationDifferentDeStateIdOperation) {
            let chargementOperationsDates = DataOperation._chargementOperationsDatesPrevisionnellesPassees(this.props.idOperation);

            chargementOperationsDates
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let listeItem = (responseFetch.reponseAPIobjet !== null ? responseFetch.reponseAPIobjet : []);

                        if (listeItem.length > 0) {
                            this.setState({
                                items: listeItem,
                                idOperation: listeItem[0].idOperation,
                                onAfficheModal: true
                            });
                        }
                    }
                });
        }
    };

    render = () => {
        const { items, onAfficheModal } = this.state;

        return (<Modal
            isOpen={onAfficheModal}
            onDismiss={() => this.setState({ onAfficheModal: false })}
            containerClassName={classNames.modalContainer}
            scrollableContentClassName={classNames.modalScrollableContent}
        >
            <div className={classNames.modalHeader}>
                <h3>Dates prévisionnelles</h3>
            </div>
            <div className={classNames.modalBody}>
                <p>Les dates prévisionnelles suivantes sont dépassées, merci d'indiquer des dates réelles ou de les mettre à jour.</p>
                <DetailsList
                    items={items}
                    columns={this.columns}
                    selectionMode={SelectionMode.none}
                    onShouldVirtualize={() => false} // Cette fonction permet de résoudre le bug d'affichage de la liste lors du scroll dans le modal
                />
            </div>
            <div className={classNames.modalFooter}>
                <DefaultButton onClick={() => this.setState({ onAfficheModal: false })} text="Fermer" />
            </div>
        </Modal>)
    };

}
